export enum BillingSectionType {
  BILLING_INFO = 'billing_info',
  ADD_PAYMENT_METHOD = 'add_payment_method',
  PAYMENT_METHOD = 'payment_method',
  AUTO_PAYMENTS = 'auto_payments',
  TOP_UP = 'top_up',
  BUY_CREDITS = 'buy_credits',
  ENABLE_PRO = 'enable_pro',
  STRIPE_FORM = 'stripe_form',
  NONE = '',
}
